// extracted by mini-css-extract-plugin
var _1 = "aNb4J";
var _2 = "MCY73";
export { _1 as "base", _2 as "input" }
